exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filed-textarea[data-v-34f0dfbe] textarea {\n  padding-right: 70px;\n}\n", ""]);

// exports
